import * as React from "react";

const Error404Svg = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={900}
    height={600}
    viewBox='0 0 900 600'
    fill='none'
    {...props}
  >
    <path fill='transparent' d='M0 0h900v600H0z' />
    <rect
      width={588.237}
      height={369.687}
      x={179.031}
      y={138.913}
      fill='#fff'
      stroke='#E1E4E5'
      strokeWidth={4}
      rx={28}
    />
    <rect
      width={63.943}
      height={23.177}
      x={630.851}
      y={166.091}
      fill='#fff'
      stroke='#E1E4E5'
      strokeWidth={4}
      rx={11.589}
    />
    <rect
      width={63.943}
      height={23.177}
      x={544.79}
      y={166.091}
      fill='#fff'
      stroke='#E1E4E5'
      strokeWidth={4}
      rx={11.589}
    />
    <rect
      width={23.177}
      height={23.177}
      x={499.495}
      y={166.091}
      fill='#fff'
      stroke='#E1E4E5'
      strokeWidth={4}
      rx={11.589}
    />
    <path
      fill='#E1E4E5'
      d='M252.553 381.315h79.058v28.953h33.296v-28.953h20.428v-27.908h-20.428v-107.85h-43.591L252.553 353.89v27.425zm79.701-27.908h-44.636v-1.287l43.349-68.602h1.287v69.889zm140.864 60.48c41.419 0 66.431-31.527 66.512-85.814.08-53.884-25.254-84.768-66.512-84.768-41.338 0-66.431 30.803-66.511 84.768-.161 54.126 25.012 85.733 66.511 85.814zm0-28.873c-18.899 0-31.124-18.98-31.044-56.941.081-37.397 12.225-56.217 31.044-56.217 18.739 0 30.964 18.82 30.964 56.217.08 37.961-12.144 56.941-30.964 56.941zm88.85-3.699h79.058v28.953h33.296v-28.953h20.428v-27.908h-20.428v-107.85h-43.591L561.968 353.89v27.425zm79.701-27.908h-44.636v-1.287l43.349-68.602h1.287v69.889z'
    />
    <rect
      width={18.648}
      height={18.648}
      x={216.399}
      y={166.091}
      fill='#fff'
      stroke='#E1E4E5'
      strokeWidth={4}
      rx={9.324}
    />
    <circle
      r={11.833}
      fill='#00B56C'
      transform='matrix(1 0 0 -1 186.698 399.545)'
    />
    <circle
      r={16.569}
      fill='#00B56C'
      transform='scale(-1 1) rotate(30 -842.37 -1310.527)'
    />
    <circle
      r={12.349}
      fill='#E1E4E5'
      transform='matrix(-1 0 0 1 466.813 177.572)'
    />
    <circle cx={319.16} cy={131.833} r={16.435} fill='#00B56C' />
    <circle
      cx={554.114}
      cy={443.789}
      r={13.589}
      fill='#00B56C'
      transform='rotate(180 554.114 443.789)'
    />
    <circle
      r={12.49}
      fill='#E1E4E5'
      transform='matrix(-1 0 0 1 302.76 469.868)'
    />
    <circle
      r={9.36}
      fill='#E1E4E5'
      transform='scale(1 -1) rotate(-30 -593.95 -1005.323)'
    />
    <rect
      width={27.252}
      height={3.175}
      x={718.31}
      y={181.625}
      fill='#E1E4E5'
      rx={1.588}
      transform='rotate(-45 718.31 181.625)'
    />
    <rect
      width={10.119}
      height={3.175}
      x={728.759}
      y={181.7}
      fill='#E1E4E5'
      rx={1.588}
      transform='rotate(-45 728.759 181.7)'
    />
    <rect
      width={24.384}
      height={2.841}
      x={195.148}
      y={480.282}
      fill='#E1E4E5'
      rx={1.42}
      transform='rotate(-45 195.148 480.282)'
    />
    <rect
      width={9.054}
      height={2.841}
      x={204.497}
      y={480.348}
      fill='#E1E4E5'
      rx={1.42}
      transform='rotate(-45 204.497 480.348)'
    />
    <rect
      width={47.139}
      height={5.492}
      x={168.95}
      y={136.396}
      fill='#E1E4E5'
      rx={2.746}
      transform='rotate(135 168.95 136.396)'
    />
    <rect
      width={17.503}
      height={5.492}
      x={150.878}
      y={136.267}
      fill='#E1E4E5'
      rx={2.746}
      transform='rotate(135 150.878 136.267)'
    />
    <rect
      width={33.185}
      height={3.866}
      x={744.509}
      y={462.467}
      fill='#E1E4E5'
      rx={1.933}
      transform='rotate(135 744.509 462.467)'
    />
    <rect
      width={12.322}
      height={3.866}
      x={731.786}
      y={462.377}
      fill='#E1E4E5'
      rx={1.933}
      transform='rotate(135 731.786 462.377)'
    />
    <path
      fill='#E1E4E5'
      fillRule='evenodd'
      d='M708.429 102.773h3.304c.799 0 1.442.65 1.442 1.442v3.304c0 .799-.65 1.442-1.442 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304a1.439 1.439 0 0 1 1.442-1.442zm11.455 0h3.304c.792 0 1.442.65 1.442 1.442v3.304c0 .799-.65 1.442-1.442 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304c0-.792.65-1.442 1.442-1.442zm11.463 0h3.304c.793 0 1.443.65 1.443 1.442v3.304c0 .799-.65 1.442-1.443 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304a1.439 1.439 0 0 1 1.442-1.442zm11.456 0h3.304c.792 0 1.442.65 1.442 1.442v3.304c0 .799-.65 1.442-1.442 1.442h-3.304a1.45 1.45 0 0 1-1.449-1.442v-3.304a1.458 1.458 0 0 1 1.449-1.442zm11.456 0h3.304c.799 0 1.449.65 1.449 1.442v3.304c0 .799-.65 1.442-1.449 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304c0-.792.65-1.442 1.442-1.442zm-33.955 12.492h3.304c.793 0 1.443.65 1.443 1.442v3.311c0 .792-.65 1.442-1.443 1.442h-3.304c-.799 0-1.442-.65-1.442-1.442v-3.304a1.44 1.44 0 0 1 1.442-1.449zm11.456 0h3.304c.792 0 1.442.65 1.442 1.442v3.311c0 .792-.65 1.442-1.442 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304a1.44 1.44 0 0 1 1.442-1.449zm11.456 0h3.304c.799 0 1.449.65 1.449 1.442v3.311a1.45 1.45 0 0 1-1.449 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304c0-.799.65-1.449 1.442-1.449zm-11.869-25.912h3.304c.793 0 1.443.65 1.443 1.442V94.1c0 .798-.65 1.442-1.443 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.305a1.439 1.439 0 0 1 1.442-1.442zm11.456 0h3.304c.792 0 1.442.65 1.442 1.442V94.1c0 .798-.65 1.442-1.442 1.442h-3.304a1.45 1.45 0 0 1-1.449-1.442v-3.305a1.458 1.458 0 0 1 1.449-1.442zm-631.14 402.96h3.304c.799 0 1.442.65 1.442 1.442v3.304c0 .799-.65 1.442-1.442 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304a1.439 1.439 0 0 1 1.442-1.442zm11.455 0h3.304c.793 0 1.443.65 1.443 1.442v3.304c0 .799-.65 1.442-1.443 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304c0-.792.65-1.442 1.442-1.442zm11.463 0h3.305c.792 0 1.442.65 1.442 1.442v3.304c0 .799-.65 1.442-1.442 1.442h-3.305c-.792 0-1.442-.65-1.442-1.442v-3.304a1.44 1.44 0 0 1 1.442-1.442zm11.456 0h3.304c.792 0 1.442.65 1.442 1.442v3.304c0 .799-.65 1.442-1.442 1.442h-3.304a1.45 1.45 0 0 1-1.449-1.442v-3.304a1.458 1.458 0 0 1 1.449-1.442zm11.456 0h3.304c.799 0 1.449.65 1.449 1.442v3.304c0 .799-.65 1.442-1.449 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304c0-.792.65-1.442 1.442-1.442zm-33.954 12.492h3.304c.792 0 1.442.65 1.442 1.442v3.311c0 .792-.65 1.442-1.442 1.442h-3.304c-.799 0-1.443-.65-1.443-1.442v-3.304a1.442 1.442 0 0 1 1.443-1.449zm11.455 0h3.304c.792 0 1.442.65 1.442 1.442v3.311c0 .792-.65 1.442-1.442 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304a1.44 1.44 0 0 1 1.442-1.449zm11.456 0h3.304c.799 0 1.449.65 1.449 1.442v3.311a1.45 1.45 0 0 1-1.449 1.442h-3.304c-.792 0-1.442-.65-1.442-1.442v-3.304c0-.799.65-1.449 1.442-1.449zm-11.868-25.912h3.304c.792 0 1.442.65 1.442 1.443v3.304c0 .799-.65 1.442-1.442 1.442h-3.304c-.793 0-1.443-.65-1.443-1.442v-3.304a1.44 1.44 0 0 1 1.443-1.443zm11.455 0h3.304c.792 0 1.442.65 1.442 1.443v3.304c0 .799-.65 1.442-1.442 1.442h-3.304a1.45 1.45 0 0 1-1.449-1.442v-3.304a1.458 1.458 0 0 1 1.449-1.443z'
      clipRule='evenodd'
    />
    <path
      fill='#00B56C'
      fillRule='evenodd'
      d='M180.882 325.922c-24.64 0-44.617-20.259-44.617-45.246 0-24.987 19.977-45.245 44.617-45.245 24.64 0 44.617 20.258 44.617 45.245s-19.977 45.246-44.617 45.246z'
      clipRule='evenodd'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={7.405}
      d='m198.857 261.476-18.848 20.109-11.316-12.064'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={7.405}
      d='m161.178 300.835 18.848-20.109 11.316 12.064'
    />
  </svg>
);
export default Error404Svg;
